import React from "react";

const Credits = () => {
    return (
        <div>
            <div>
            <header className="pixelated-header">
                <h1>Credits</h1>
            </header>
            </div> 
            <p className="MediumText">
                Game Developer: Boijy <br/>
                Website Developer: Boijy<br/>
                Website made on: React<br/>
                <br/><br/>
                GAME'S RELEASE DATE: 5th August
            </p>
        </div>
    )
}

export default Credits;